import React from 'react';
import FileStorage from '../components/FileStorage';

const CMC = () => {
  return (
    <FileStorage
      category="cmc"
      title="Chemistry, Manufacturing, and Controls (CMC)"
      description="Manufacturing processes, quality control procedures, and regulatory compliance documents"
    />
  );
};

export default CMC;